import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "19",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M22.43 0H4.57C3.356 0 2.194.49 1.337 1.36A4.683 4.683 0 0 0 0 4.644v9.712c0 1.231.481 2.413 1.338 3.284A4.532 4.532 0 0 0 4.57 19h17.862c1.212 0 2.374-.49 3.23-1.36A4.684 4.684 0 0 0 27 14.356V4.644a4.683 4.683 0 0 0-1.338-3.284A4.532 4.532 0 0 0 22.43 0Zm-3.642 9.686-8.1 4.222a.205.205 0 0 1-.276-.083.214.214 0 0 1-.027-.103V5.278a.214.214 0 0 1 .1-.18.205.205 0 0 1 .203-.006l8.1 4.222a.21.21 0 0 1 .113.188.214.214 0 0 1-.113.188v-.004Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }